import { Button } from 'primereact/button';
import { Divider } from 'primereact/divider';
import { FileUpload } from 'primereact/fileupload';
import { Message } from 'primereact/message';
import { ProgressSpinner } from 'primereact/progressspinner';
import { useRef, useState } from 'react';
import slugify from 'react-slugify';
import FormInput from '../../../../components/Form/FormInput';
import { useAccountContext } from '../../../../contexts/AccountContext';
import { useImageCompressingContext } from '../../../../contexts/ImageCompressingContext';
import { useToastContext } from '../../../../contexts/ToastContext';
import { privateFetch } from '../../../../utils/apiHelper';
import { CONSTANT } from '../../../../utils/constants';
import { computeImageShape } from '../../../../utils/imageHelper';
import ImageItem from '../../common/image/ImageItem';

function MainImageForm({
  mainImage,
  setMainImage,
  ratio,
  label = 'Photo principale (max. 10Mo)',
  required = true
}) {
  const { accountContext } = useAccountContext();
  const [imageLoading, setImageLoading] = useState(false);
  const fileUploadRef = useRef(null);
  const { setImageCompressingContext } = useImageCompressingContext();
  const { showToast } = useToastContext();
  const [imageIsValid, setImageIsValid] = useState(true);

  const uploadImage = async (imageForm) => {
    await privateFetch(
      'POST',
      'resources',
      `/cu/${accountContext.id}/image/`,
      "L'image a bien été ajoutée",
      imageForm,
      false,
      true
    ).then((res) => {
      setMainImage(res);
      setImageCompressingContext({
        image: res,
        file: imageForm.get('file')
      });
    });
    setImageLoading(false);
  };

  const onUpload = (event) => {
    if (event.files[0].size > CONSTANT.maxImageSize) {
      showToast('warn', '10Mo max.');
      onClear();
    } else {
      setImageLoading(true);

      const file = event.files[0];
      const imageForm = new FormData();
      imageForm.append('title', slugify(file.title));
      imageForm.append('file', file);
      uploadImage(imageForm);
    }
  };

  const onClear = () => {
    setMainImage(undefined);
    fileUploadRef.current.clear();
  };

  const handleImageLoad = (event) => {
    const isValid = computeImageShape(event, ratio);
    setImageIsValid(isValid);
  };
  return (
    <>
      <FormInput key={'file'} label={label} required={required} isValid={mainImage}>
        {!imageIsValid && mainImage && (
          <Message
            severity="error"
            text={`Cette image n'a pas le bon ratio (${ratio}:1) l'affichage sur le site vitrine ne sera optimal.`}
          />
        )}

        {mainImage && (
          <ImageItem
            mainImageMode
            imageClassName={'max-w-[400px] max-h-[400px] object-contain object-left mb-5'}
            image={mainImage}
            imageLoad={ratio && handleImageLoad}
          />
        )}
        <div className="flex flex-row gap-x-3">
          {mainImage && (
            <Button
              key={'delete-img'}
              label={"Supprimer l'image"}
              outlined
              onClick={onClear}
              severity="danger"
            />
          )}
          {imageLoading ? (
            <div className="w-[50px] h-[50px] p-1">
              <ProgressSpinner style={{ width: '42px', height: '42px' }} />
            </div>
          ) : (
            <FileUpload
              ref={fileUploadRef}
              auto
              disabled={mainImage}
              mode="basic"
              title="file"
              accept="image/*"
              customUpload
              uploadHandler={onUpload}
              chooseLabel="Depuis mon ordinateur"
            />
          )}
        </div>
      </FormInput>
      <Divider />
    </>
  );
}

export default MainImageForm;
